import { useContext } from "react";
import { LocaleContext } from "../components/localization_wrapper";
import { apiClient } from "../client";
import { flowForKey, streetsForFlow } from "../flows";
import { NEXT_STREET_EVENT } from "../constants";

function completedStreetsForFlow(flowKey) {
  return apiClient.treesponses
    .filter(
      (treesponse) =>
        treesponse.getAnswer("flow") === flowKey &&
        treesponse.getAnswer("completed") === true,
    )
    .map((treesponse) => treesponse.getAnswer("street"))
    .filter(Boolean);
}

function dispatchNextStreet(flowKey, streetKey) {
  window.dispatchEvent(
    new CustomEvent(NEXT_STREET_EVENT, {
      detail: { flow: flowKey, street: streetKey },
    }),
  );
}

export function NextStreet({ page }) {
  const i18n = useContext(LocaleContext);
  const flowKey = page.treesponse.getAnswer("flow");
  const currentStreet = page.treesponse.getAnswer("street");
  const flow = flowForKey(flowKey);
  const completedStreets = new Set(completedStreetsForFlow(flowKey));
  completedStreets.add(currentStreet);

  const streets = streetsForFlow(flowKey).filter(
    (street) => !completedStreets.has(street.key),
  );

  if (!flow) return null;

  if (streets.length === 0) {
    return (
      <main className="next">
        <div className="next__content">
          <div>
            <h1 className="next__title">{i18n.t("next.done_title")}</h1>
            <p className="next__description">
              {i18n.t("next.done_description")}
            </p>
          </div>
          <NextFooter i18n={i18n} />
        </div>
      </main>
    );
  }

  return (
    <main className="next">
      <div className="next__content">
        <div className="next__top">
          <div className="next__intro">
            <h1 className="next__title">{i18n.t("next.title")}</h1>
            <p className="next__description">{i18n.t("next.description")}</p>
          </div>
          <div className="next__options">
            {streets.map((street) => (
              <button
                className="next__link next__link--button"
                key={street.key}
                type="button"
                onClick={() => dispatchNextStreet(flowKey, street.key)}
              >
                <span>{i18n.t(street.name)}</span>
              </button>
            ))}
          </div>
        </div>
        <NextFooter i18n={i18n} />
      </div>
    </main>
  );
}

function NextFooter({ i18n }) {
  return (
    <div className="next__footer">
      <a
        className="next__link--home"
        href="https://herentaanzet.be/mobiliteitsplan"
      >
        <span>{i18n.t("next.to_homepage")}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
        </svg>
      </a>
      <svg
        className="next__decoration"
        viewBox="0 0 117 117"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="117" cy="117" r="58" fill="var(--color-green)" />
      </svg>
    </div>
  );
}
